import { render, staticRenderFns } from "./ManageCod.vue?vue&type=template&id=f5eeab88&"
import script from "./ManageCod.vue?vue&type=script&lang=js&"
export * from "./ManageCod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports